'use strict';

/*
 * EPROC-10643: reads/writes the supplier contact persons of an order via the order-v2 API.
 * GET  /order/v2/:orderId/supplier-contacts -> selectable contacts (with `selected` flag)
 * PUT  /order/v2/:orderId/supplier-contacts -> replace the selection
 * The bearer token is added globally by apiConfig, so no auth handling is needed here.
 */
module.exports = /* @ngInject */ function ($resource, apiConfig) {

	const BASE = apiConfig.$get().apiUrl;
	const PATH = 'order/v2/:orderId/supplier-contacts';

	return {
		list: $resource(
			`${BASE}/${PATH}`,
			{ orderId: '@orderId' },
			{
				query: {
					method: 'GET',
					isArray: true
				}
			}
		),
		save: $resource(
			`${BASE}/${PATH}`,
			{ orderId: '@orderId' },
			{
				update: {
					method: 'PUT'
				}
			}
		)
	};

}
